import { render, staticRenderFns } from "./LayoutElement.vue?vue&type=template&id=453c09b4"
import script from "./LayoutElement.vue?vue&type=script&lang=js"
export * from "./LayoutElement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports